import _extends from "@babel/runtime/helpers/esm/extends";

/**
 * @param {string} baseUrl
 * @param {string[]} versions
 * @param {string} activeVersion
 */
export var createCdnReset = function createCdnReset(baseUrl, versions, activeVersion) {
  if (baseUrl === void 0) {
    baseUrl = 'https://shared.mediahuis.be';
  }

  if (versions === void 0) {
    versions = ['v1'];
  }

  if (activeVersion === void 0) {
    activeVersion = 'v1';
  }

  var vs = {};
  [].concat(versions, ['latest']).forEach(function (v) {
    return vs[v] = baseUrl + "/reset/" + v + "/index.min.css";
  });
  return _extends({
    activeVersion: activeVersion
  }, vs);
};
/**
 * @param {string} baseUrl
 * @param {string[]} versions
 * @param {string} activeVersion
 */

export var createCdnFont = function createCdnFont(baseUrl, versions, activeVersion, latest, prefix) {
  if (baseUrl === void 0) {
    baseUrl = 'https://shared.mediahuis.be';
  }

  if (versions === void 0) {
    versions = ['v1.0.0'];
  }

  if (activeVersion === void 0) {
    activeVersion = 'v1.0.0';
  }

  if (latest === void 0) {
    latest = 'latest';
  }

  if (prefix === void 0) {
    prefix = '';
  }

  var vs = {};
  [].concat(versions, [latest]).forEach(function (v) {
    return vs[v] = baseUrl + "/fonts/" + prefix + v + "/fonts.css";
  });
  return _extends({
    activeVersion: activeVersion
  }, vs);
};